import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames'; 
import PersonalProtectiveEquipmentDelivery from '../Forms/PersonalProtectiveEquipmentDelivery';

const AddEditPersonalProtectiveEquipmentDeliveryModal = ({
	dataPersonalProtectiveEquipment,
	isOpen, 
	handleToggleModalDeliver,
	activeTab,
	toggleTab,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModalDeliver}>
				Entregar Elementos de Protección Personal
			</ModalHeader>

			<div className='modal-content border-0 mt-3'>
				<Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
					<NavItem>
						<NavLink href='#' className={classnames({ active: activeTab === '1' })} onClick={() => { toggleTab('1'); }}>
							Información General
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink href='#' className={classnames({ active: activeTab === '2' })} onClick={() => { toggleTab('2'); }}>
							Items para Entregar
						</NavLink>
					</NavItem> 
				</Nav>
			</div>

			<PersonalProtectiveEquipmentDelivery
				dataPersonalProtectiveEquipment={dataPersonalProtectiveEquipment}
				isOpen={isOpen}
				handleToggleModalDeliver={handleToggleModalDeliver}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
		</Modal>
	);
};

export default AddEditPersonalProtectiveEquipmentDeliveryModal;
